export interface ServiceCondition {
  id: string;
  name: string;
  status: "required" | "optional";
  position: number;
}

export interface ServiceConditionFormValues {
  name: string;
  content: string;
  status: "required" | "optional";
}

export const emptyServiceConditionForm: ServiceConditionFormValues = {
  name: "",
  content: "",
  status: "required",
};
